const instagramFeedElements = document.querySelectorAll('[data-instagram-feed]');

let instagramFeeds = [];
let args = {};

instagramFeedElements.forEach(function(e) {
  // const id = '';

  args = {
    target: e,
    get: 'user',
    userId: phpVars.instagram_user_id,
    // clientId: phpVars.instagram_client_id,
    accessToken: phpVars.instagram_access_token,
    links: true,
    limit: 4,
    resolution: 'standard_resolution',
    template: `
      <a href="{{link}}" target="_blank" id="{{id}}" style="background-image: url({{image}});" class="instagram-feed-post">
        <span class="instagram-feed-overlay">
          <span class="instagram-feed-caption">{{caption}}</span>
          <span class="instagram-feed-likes">❤️ {{likes}}</span>
        </span>
      </a>`
  };

  instagramFeeds[e.id] = new Instafeed(args);

  instagramFeeds[e.id].run();

});
